import React, { useState } from 'react'

import { Step, StepLabel, Stepper, useMediaQuery } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import { isEmpty } from 'lodash'

import { UnsavedChangesDialog } from '../../components'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

import useStyles from './styles'
import theme from 'theme'

const ThirdPartyManagementStepper = () => {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [pendingStep, setPendingStep] = useState(null)

  const { activeStep, handleStep, isCompleted, isShow, isPreAvaliation } =
    useThirdPartyManagementStepper()
  const formContext = useFormContext()
  const classes = useStyles()
  const matches = useMediaQuery(theme.breakpoints.up('md'))

  const dirtyFields = formContext?.formState?.dirtyFields

  const steps = [
    ...(isShow ? ['Visão Geral'] : []),
    'Informações Gerais',
    'Avaliações',
    ...(isPreAvaliation ? [] : ['Contrato']),
    'Riscos',
  ]

  const handleStepClick = (index) => {
    if (index === activeStep) return

    if (!isEmpty(dirtyFields)) {
      setPendingStep(index)
      setConfirmOpen(true)
      return
    }

    handleStep(index)
  }

  const handleConfirmChangeStep = () => {
    setConfirmOpen(false)

    if (pendingStep !== null) handleStep(pendingStep)

    setPendingStep(null)
  }

  return (
    <>
      <Stepper
        activeStep={activeStep}
        orientation={matches ? 'horizontal' : 'vertical'}
      >
        {steps.map((step, index) => (
          <Step
            key={step}
            onClick={() => handleStepClick(index)}
            completed={isCompleted(index)}
            className={classes.stepper}
          >
            <StepLabel>{step}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <UnsavedChangesDialog
        open={confirmOpen}
        setOpen={setConfirmOpen}
        onConfirm={handleConfirmChangeStep}
      />
    </>
  )
}

export default ThirdPartyManagementStepper
